import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<Theme>()((theme) => ({}));
export default useStyles;
